import { queryClient } from '@alfa-bank/newclick-global';
import { getQueryKeyFromApiMethod } from '../get-query-key-from-api-method';
/**
 * Записывает данные в кеша react-query на основе интерфейса @type {ApiMethod}
 */
export const setCachedDataByApiMethod = (apiMethod, response, options) => {
    const queryKey = getQueryKeyFromApiMethod(apiMethod, options?.params);
    // Кешируем только GET запросы
    if (response.config?.method?.toLowerCase() === 'get') {
        queryClient.setQueryData(queryKey, response);
    }
};
